import clsx from 'clsx';
import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

interface Props {
  placeholderText: string;
  selectedDate: Date | null;
  onChange: (data: Date | null) => void;
  maxDate?: Date;
  minDate?: Date;
  className?: string;
  disabled?: boolean;
}

const BrollyDatePicker: React.FC<Props> = ({ 
  onChange, 
  placeholderText, 
  selectedDate, 
  maxDate, 
  minDate,
  className = "",
  disabled = false
}) => {
  return (
    <DatePicker
      selected={selectedDate}
      onChange={onChange}
      className={clsx(
        "rounded-full cursor-pointer border shadow-sm w-full max-w-[10rem] text-sm px-3 py-2 transition-colors",
        "bg-white dark:bg-darkBg border-gray-300 dark:border-darkBg-border",
        "text-gray-900 dark:text-darkBg-mainText placeholder-gray-500 dark:placeholder-gray-400",
        "focus:border-primary-500 dark:focus:border-primary-400",
        "hover:border-gray-400 dark:hover:border-darkBg-border",
        disabled && "cursor-not-allowed opacity-50 bg-gray-100 dark:bg-gray-800",
        selectedDate ? "font-medium" : "font-normal",
        className
      )}
      placeholderText={placeholderText}
      disabled={disabled}
      showMonthDropdown
      showYearDropdown
      maxDate={maxDate}
      minDate={minDate}
      popperClassName="dark-theme-datepicker"
    />
  );
};

export default BrollyDatePicker;
